import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import SupplierActionsMenu from './SupplierActionsMenu';
import { Box } from '@mui/material';
import CustomPagination from '../../../components/customPagination';
import { useGetSuppliersHandler } from '../dataHandlers/getSuppliersHandler';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const SuppliersTable = ({ handlePaginationChange, searchQuery = {} }) => {
  const { suppliers, totalDocuments, isLoading } = useGetSuppliersHandler({ searchQuery });
  const { suppliers: s } = useTranslatedMessages();
  const col = s.table.columns;
  const na = s.table.not_available;

  const columns = [
    {
      field: 'name',
      headerName: col.name,
      flex: 1,
    },
    {
      field: 'email',
      headerName: col.contact_info,
      flex: 1,
      renderCell: (params) => {
        const contacts = [];
        if (params.row.email) contacts.push(params.row.email);
        if (params.row.telephone) contacts.push(params.row.telephone);
        return contacts.join(' / ') || na;
      },
    },
    {
      field: 'peppol_participant',
      headerName: col.peppol_id,
      flex: 1,
      renderCell: (params) => {
        const { endpoint_id, endpoint_scheme_id } = params.row;
        return endpoint_id && endpoint_scheme_id ? `${endpoint_scheme_id}:${endpoint_id}` : '-';
      },
    },
    {
      field: 'company_id',
      headerName: col.business_identifier,
      flex: 1,
    },
    {
      field: 'address',
      headerName: col.country,
      flex: 1,
      renderCell: (params) => {
        const address = params.row.postal_address;
        if (!address) return na;
        return `${address.country}`;
      },
    },
    {
      field: 'actions',
      headerName: col.actions,
      flex: 0.5,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return <SupplierActionsMenu supplier={params.row} />;
      },
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={suppliers}
        columns={columns}
        getRowId={(row) => row.id}
        paginationMode="server"
        loading={isLoading}
        rowCount={totalDocuments}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          handlePaginationChange(model.page, model.pageSize);
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default SuppliersTable;
